/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Space, Typography } from 'antd';
import NodeWrapper from '../../NodeWrapper';
import LimitedConnectionsHandle from '../../LimitedConnectionsHandle';
import NlpPipelineLink from '../../../UI/NlpPipelineLink';

// Misc imports
import { NODE_TYPES_PROPERTIES } from '../../../../constants/flowGraph';

// Constant declarations
const { Text } = Typography;

const NlpFlowPipelineNode = ({ id, type, data, dragging, selected }) => {
  const nodeProps = NODE_TYPES_PROPERTIES[type];
  const { pipelineId } = data || {};
  const { t } = useTranslation();

  const NodeContents = useMemo(() => {
    return (
      <Fragment>
        <LimitedConnectionsHandle type="target" position="top" />

        <Space size={6} className="node-header">
          {nodeProps.icon}
          {nodeProps.label}
        </Space>

        {
          pipelineId ? (
            <Text>
              <NlpPipelineLink pipelineId={pipelineId} />
            </Text>
          ) : (
            <Text type="secondary">
              {t('Click to choose pipeline')}
            </Text>
          )
        }
      </Fragment>
    );
  }, [data, nodeProps]);

  return (
    <NodeWrapper
      id={id}
      type={type}
      data={data}
      children={NodeContents}
      dragging={dragging}
      selected={selected}
    />
  );
};

// https://reactflow.dev/docs/api/nodes/node-options/
NlpFlowPipelineNode.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  dragging: PropTypes.bool,
  selected: PropTypes.bool,
  type: PropTypes.string,
  xPos: PropTypes.number,
  yPos: PropTypes.number
};

export default memo(NlpFlowPipelineNode);
